// import PcIndex from './components/oldPc/oldPcIndex.js'
import PcIndex from './components/newPc/index.js'
import MobileIndex from './components/mobileIndex/index.js'
import { getTerminalType } from './common/utils.js'

import { useEffect, useState } from 'react'

function MixApp() {
  const [platform, setPlatform] = useState(3);
  useEffect(() => {
    const terminalType = getTerminalType();
    if (terminalType === 'android') {
      setPlatform(1)
    } else if (terminalType === 'ios') {
      setPlatform(2)
    } else {
      setPlatform(3)
    }
  })
  return platform === 3 ? <PcIndex/> : <MobileIndex/>
}

export default MixApp
